'use client';

import React from 'react';
import { Avatar, AvatarProps } from '../../components/Avatar';

export interface AvatarGroupProps {
  avatars: Array<AvatarProps>;
}

export const AvatarGroup: React.FC<AvatarGroupProps> = ({ avatars }) => (
  <div className="inline-flex items-center space-x-2">
    {avatars.map((avatar: AvatarProps) => {
      return (
        <div className="w-5" key={avatar.photo}>
          <Avatar {...avatar} />
        </div>
      );
    })}
  </div>
);
